if(templateSiteSelected == 'Suites'){
    (function(){
		console.log(templateSiteSelected);
		////***** BOOKING WIDGET SUITES *****////
		if(document.getElementById('container-booking-widget')){
			let actualDay = new Date();
			let actualDayMore = new Date();
			actualDayMore.setDate(actualDay.getDate() + 3);	
			let checkInBooking = document.getElementById('checkin-in');
			let checkOutBooking = document.getElementById('checkout-out');
			
			flatpickr(checkInBooking, {
				showMonths: 1,
				minDate : actualDay,
				dateFormat: 'm/d/Y',
				allowInput: true,
				defaultDate: [actualDay],
				onChange: function(selectedDates){
					const firstDate = selectedDates[0];
					const endDatePicker = flatpickr(checkOutBooking,{
						dateFormat: 'm/d/Y'
					});
					let newDateFlat2 = new Date(selectedDates[0]);
					newDateFlat2.setDate(newDateFlat2.getDate() + 3);	
					endDatePicker.set("minDate", firstDate);
					endDatePicker.setDate(newDateFlat2)
				}
			});

            flatpickr(checkOutBooking, {
				showMonths: 1,
				minDate : actualDay,
				dateFormat: 'm/d/Y',
				allowInput: true,
				defaultDate: [actualDayMore]
			});
		}

		let allButtons = document.querySelectorAll('.btn:not(.skip-to-content), .btn-white');
		allButtons.forEach((button)=>{
			button.innerHTML = `<span>${button.textContent}</span>`;
		});

		if(document.querySelector('.js-open-properties-list')){
			document.querySelector('.js-open-properties-list').addEventListener('click', (e)=>{
				e.preventDefault();
				document.getElementById('all-properties').classList.add('show');
			})
		}

		if(document.querySelector('.js-close-all-all-properties')){
			document.querySelector('.js-close-all-all-properties').addEventListener('click', ()=>{
					document.getElementById('all-properties').classList.remove('show');
			})
		}
    })();
}